import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: [],
  product_variations: [],  // Fixed typo from 'product_variatons' to 'product_variations'
  auditHistory: [],        // To store audit records
  meta: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 20,
  },
  loading: false,
  error: null,
};

const productSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    // Fetch products
    fetchProductsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchProductsSuccess(state, action) {
      state.loading = false;
      state.products = action.payload.products;
      state.meta = action.payload.meta;
    },
    fetchProductsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    // Update products
    updateProductRequest(state) {
      state.loading = true;
      state.error = null;
    },
    updateProductSuccess(state, action) {
      state.loading = false;
      //const updatedProduct = action.payload;
      // Find and update the product in the state (if needed)
      // const index = state.products.findIndex((p) => p.id === updatedProduct.id);
      // if (index !== -1) {
      //   state.products[index] = updatedProduct;
      // }
    },
    updateProductFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    // Fetch audit history
    fetchAuditHistoryRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchAuditHistorySuccess(state, action) {
      state.loading = false;
      state.auditHistory = action.payload;  // Storing audit records
    },
    fetchAuditHistoryFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    // Create new audit history record
    createAuditHistoryRequest(state) {
      state.loading = true;
      state.error = null;
    },
    createAuditHistorySuccess(state, action) {
      state.loading = false;
      state.auditHistory.push(action.payload);  // Add new audit record to the list
    },
    createAuditHistoryFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    // Fetch product variants
    fetchProductsVariantsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchProductsVariantsSuccess(state, action) {
      state.loading = false;
      state.product_variations = action.payload;  // Store product variations
    },
    fetchProductsVariantsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchProductsRequest,
  fetchProductsSuccess,
  fetchProductsFailure,
  updateProductRequest,
  updateProductSuccess,
  updateProductFailure,
  fetchAuditHistoryRequest,
  fetchAuditHistorySuccess,
  fetchAuditHistoryFailure,
  createAuditHistoryRequest,
  createAuditHistorySuccess,
  createAuditHistoryFailure,
  fetchProductsVariantsRequest,
  fetchProductsVariantsSuccess,
  fetchProductsVariantsFailure,
} = productSlice.actions;

export default productSlice.reducer;
